import type { CourseGroup } from '@/views/Onboarding/Show';
import type { CourseGroup as CourseGroupList } from '@/views/Onboarding/List';

export default {
  courseGroups: null as CourseGroupList[] | null,
  courseGroup: null as CourseGroup | null,
};
